<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!---------------------------------------- Table Content --------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- smsSenderAgent -->
        <td>
          <span copyToClipboard>{{ item?.title }}</span>
        </td>

        <!-- deliveryStatuses -->
        <td>
          <app-expand-item
            *ngIf="item?.deliveryStatuses?.length > 1"
            [isCustom]="true"
            [placement]="'left'"
          >
            <ul class="custom dir-rtl tw-mb-0">
              <li *ngFor="let item of item?.deliveryStatuses" class="tw-mb-1">
                {{ item | enumToText : DeliveryStatusEnumValues }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.deliveryStatuses?.length < 2"
            copyToClipboard
            type="number"
            [value]="
              item?.deliveryStatuses[0] | enumToText : DeliveryStatusEnumValues
            "
          >
          </td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onUpdate)="
              onUpdateRefundDeliveryStatusType(
                item?.id,
                item?.deliveryStatuses,
                item?.title
              )
            "
            (onDelete)="onDelete($event.id, $event.name)"
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-refund-delivery-status-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-refund-delivery-status-form>
</ng-container>
<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
